module.exports = __webpack_public_path__ + "img/esg-3-1.82b9f66a.png";